import React, {useState, useEffect} from  'react';
import api from '../../services/api';
import Select from 'react-select';

export default function StatusSelect(props){

    const [statusList, setStatusList] = useState([]);
    const [defaultValue, setDefaultValue] = useState(null);
    const [options, setOptions] = useState([]);

    const onChange = (option) => {        
        props.onChange(option.value);
    };

    const getStatusList = () => {
        api.get('/issues/get_status_list')
        .then(response => {     
            setStatusList(response.data.data);                   
        });         
    }

    const getOptions = () => {
        let options = [
            {value: null, label: (props.label ? props.label : '-- Selecione --')} 
        ];        
        statusList.map((item, index) => {
            let option = {
                value: item.id,
                label: item.attributes.name
            };
            options.push(option);
        });
        setOptions(options);         
    };   

    useEffect(() => {        
        getStatusList();
    }, []);

    useEffect(() => {
        getOptions();
    }, [statusList]);   
    
    useEffect(() => {
        options.map((option, index) => {            
            if(option.value == props.defaultValue){
                setDefaultValue(option);                
            }            
        });
    }, [options]);

    return (
        <>
            {(options && defaultValue) && <Select options={options} defaultValue={defaultValue} onChange={onChange} />}
        </>
    );

}